import { t } from "../../../../utils/i18n";
import React from "react";
import CardRequest from "./CardRequest";
import "../../../P2PTrades/Offers/index.scss";

const List = ({ card_requests }) => {
  return (
    <div className="container-fluid px-2 px-md-5">
      <div className="create-offer-title" style={{ marginBottom: "20px" }}>
        <h2 className="_page-title font-1_8"></h2>
      </div>
      <div className="card-parent-container">
        <div className="card-header">
          <h5 className="create-trade-page-title"><i className="fa fa-address-card-o"></i>&nbsp;{t("cards.requests.your_info")} </h5>
        </div>
        <div className="card-body">
          {card_requests.length > 0 ? (
            <div className="d-flex flex-row flex-wrap">
              {card_requests.map((cardRequest, i) => (
                <CardRequest key={i} cardRequest={cardRequest} />
              ))}
            </div>
          ) : (
            <div>
              {t("cards.requests.not_requested")}{" "}
               <i className="fa fa-link"></i>{" "}
              <a href="/cards/requests/new" className="card-activate-link">{t("cards.requests.begin_link")}</a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default List;
